<template>
    <!-- <footer class="d-flex align-items-center justify-content-center mt-5">
        Copyright &copy; {{ new Date().getFullYear()}}
    </footer> -->
    <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <!-- <h4>AM</h4> -->
          <ul class="list-unstyled">
            <!-- <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Works</a></li>
            <li><a href="#about-me">About Me</a></li>
            <li><a href="#contact">Contact</a></li> -->
          </ul>
        </div>
        <div class="col-md-6">
          <!-- <h4>Address</h4> -->
          <!-- <p>Tegucigalpa, Honduras</p> -->
        </div>
        <div class="col-md-3">
          <!-- <h4>Follow Me</h4> -->
          <!-- <ul class="list-inline">
            
            <li><a href="https://github.com/andres15mol" class="iconos-apps"><i class="me-4 fa-brands fa-github"></i></a></li>
            <li><a href="https://www.linkedin.com/in/andr%C3%A9s-molina-039276230/" class="iconos-apps"><i class="me-3 fa-brands fa-linkedin"></i></a></li>
          </ul> -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>&copy; {{ new Date().getFullYear()}} Andrés Molina. All rights reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
footer {
    background: black;
    color: white;
    min-height: 3em;
    font-size: 0.8em;
}
</style>